import {Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {MatDivider} from "@angular/material/divider";
import {MatFormField} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {MatTooltip} from "@angular/material/tooltip";
import {MatDialog} from "@angular/material/dialog";
import {FormsModule} from '@angular/forms';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {DmsAttachmentTypeItem} from "../../../../model/dmsAttachmentTypeItem";
import {DmsAttachmentUploadItem} from "../../../../model/dmsAttachmentUploadItem";
import {DmsAttachmentsService} from "../../../../services/api/dms-attachments.service";
import {DmsMetaService} from "../../../../services/api/dms-meta.service";
import {DocusignService} from "../../../../services/api/docusign.service";
import {MicrosecService} from 'src/app/services/api/microsec.service';
import {Router} from "@angular/router";
import {MatSnackBar} from "@angular/material/snack-bar";
import {IncomingDataAttachments} from "../../../../shared/interfaces/shared/IncomingDataAttachments";
import {DmsNewsItem} from "../../../../model/dmsNewsItem";
import {DmsTasksService} from "../../../../services/api/dms-tasks.service";
import {DmsWfTasksService} from "../../../../services/api/dms-wf-tasks.service";
import {DialogQrCodeComponent} from 'src/app/components/shared/dialog-qr-code/dialog-qr-code.component';
import {Subscription, pipe, timer} from 'rxjs';
import {switchMap, takeUntil, takeWhile} from 'rxjs/operators';
import {UserSignaturesService} from 'src/app/services/shared/user-signatures.service';
import {DigitalSignaturesSchema} from 'src/app/model/dmsAvailableSignaturesResponseSchema';

@Component({
  selector: 'app-attachment-box-embedded',
  imports: [
    MatDivider,
    MatFormField,
    MatIcon,
    MatIconButton,
    MatOption,
    MatSelect,
    MatTooltip,
    FormsModule,
    MatCheckbox,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    NgForOf,
    NgIf,
    TranslateModule,
    NgClass,
    MatButton
  ],
  templateUrl: './attachment-box-embedded.component.html',
  styleUrl: './attachment-box-embedded.component.scss',
  standalone: true
})
export class AttachmentBoxEmbeddedComponent implements OnInit, OnDestroy{

  @Input() attachments!: IncomingDataAttachments[];
  @Input() type!: DmsNewsItem.TypeEnum | null;
  @Input() id!: number;

  @Output() attachmentUploadEvent = new EventEmitter<void>();
  @Output() attachmentSignEvent = new EventEmitter<void>();

  isErrorInData = false;

  attachmentTypes: DmsAttachmentTypeItem[] = [];
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;

  uploadList: DmsAttachmentUploadItem = {
    files: [],
    elementType: '',
    elementId: ''
  }

  isDragOver = false;

  loading= false;
  errorInSigning: string = '';
  itemsSelected: {[key: string]: boolean} = {};

  availableSignatures: DigitalSignaturesSchema[] = [];
  availableSignaturesForMultipleSign: DigitalSignaturesSchema[] = [];

  readonly MAX_FILE_SIZE = 104857600; // 100MB in bytes
  //readonly MAX_FILE_SIZE = 31457280; // 30 MB in bytes

  private readonly messageEventListener: (event: MessageEvent<any>) => void;

  constructor(
    public dmsAttachmentsService: DmsAttachmentsService,
    private dmsMetaService: DmsMetaService,
    private docusignService: DocusignService,
    private microsecService: MicrosecService,
    public dialog: MatDialog,
    private router: Router,
    private _snackBar: MatSnackBar,
    private translate: TranslateService,
    private tasksService: DmsTasksService,
    private workflowItemService: DmsWfTasksService,
    public userSignaturesService: UserSignaturesService
  ) {
    this.messageEventListener = this.receiveMessage.bind(this);
    window.addEventListener('message', this.messageEventListener);
  }

  receiveMessage(event: MessageEvent<any>) {
    if (event.data && event.data.type === 'REFRESH') {
      this.refreshAttachments(this.id, this.type ? this.type : '');
    }
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.messageEventListener);
  }

  ngOnInit() {
    this.dmsMetaService.readDmsAttachmentType$().subscribe(response => {
      if (response.result) {
        this.attachmentTypes = response.result;
      }
    })
    if(this.type && this.id) {
      this.uploadList.elementType = this.type;
      this.uploadList.elementId = this.id.toString();
    } else this.isErrorInData = true ;
    this.userSignaturesService.availableSignatures$.subscribe((signatures: DigitalSignaturesSchema[]) => {
      if (signatures && signatures.length > 0) {
        this.availableSignatures = signatures;
        this.availableSignaturesForMultipleSign = signatures.filter(i => i.type === 'microsec');
      } else {
        this.availableSignatures = [];
        this.availableSignaturesForMultipleSign = [];
      }
    });
  }

  preview(attachmentGuid: string) {
    this.dmsAttachmentsService.readDmsAttachmentPreviewByGuid$(attachmentGuid);
  }

  download(attachmentGuid: string) {
    this.dmsAttachmentsService.readDmsAttachmentByGuid$(attachmentGuid);
  }

  signDoc(attachmentGuid: string | null, type: string, signatureMethodId: number) {
    this.errorInSigning = '';
    if (type==='microsec') {
      let fileGuids: string[] = [];
      if (attachmentGuid) fileGuids.push(attachmentGuid);
      else fileGuids = Object.keys(this.itemsSelected).filter(key => this.itemsSelected[key]);
      this.microsecService.microsecStartSignaturePost$({attachmentIds: fileGuids, signatureMethodId: signatureMethodId}).subscribe({
        next: (response) => {
          if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.tryDeepLinkWithFallback(response.result.rawData);
          } else {
            this.openMicrosecQrDialog(response.result.qrCodeUri, response.result.sessionId, response.result.rawData)
          }
        },
        error: (error) => this.errorInSigning = this.translate.instant('MICROSEC_SIGN_ERROR') + error.message
      });
    }
    if (type==='docusign') {
      if (attachmentGuid) this.docusignService.docusignGetUrlByAttachmentGuid$(attachmentGuid).subscribe({
        next: (response) => window.open(response.result.url),
        error: (error) => this.errorInSigning = this.translate.instant('DOCUSIGN_SIGN_ERROR') + error.message
      });
    }
  }

  openMicrosecQrDialog(qrCodeUri: string | undefined, sessionId: string, rawData?: any, dialogTitle?: string, alternativeButtonText?: string) {
    let QRDialogOpen = true;
    const objectForDeepLink = {
      sessionUrl: rawData.sessionUrl,
      sessionId: rawData.sessionId,
      mode: rawData.mode,
      documents: rawData.documents
    };
    const deepLink = "esign:" + JSON.stringify(objectForDeepLink);
    const dialogRef = this.dialog.open(DialogQrCodeComponent,  {
      data: {
        qrCodeUri: qrCodeUri,
        dialogTitle: dialogTitle ? dialogTitle : this.translate.instant('MICROSEC_QR_TITLE'),
        dialogMessage: this.translate.instant('MICROSEC_QR_MESSAGE'),
        alternativeButtonText: rawData.sessionUrl ? (alternativeButtonText ? alternativeButtonText : this.translate.instant('MICROSEC_QR_ALT_BUTTON')) : undefined,
        alternativeButtonLink: deepLink
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      QRDialogOpen = false;
    });
    const subscription: Subscription = 
      timer(0, 3000).pipe( // Poll backend every 3 seconds
        takeUntil(timer(300000)), // Stop polling after 5 minutes
        takeWhile(() => QRDialogOpen), // Stop polling if dialog is closed
        switchMap(() => this.microsecService.microsecCheckSignatureStatusGet$(sessionId))
      ).subscribe({
        next: (response) => {
          console.log('Microsec signature status:', response.result.status);
          if (response.result.status === 'signed' || response.result.status === 'aborted') {
            subscription.unsubscribe();
            dialogRef.close();
          }
          if (response.result.status === 'signed') {
            this.refreshAttachments(this.id, this.type ? this.type : '');
            this.attachmentSignEvent.emit();
          }
          if (response.result.status === 'aborted') this.errorInSigning = this.translate.instant('MICROSEC_SIGN_ABORTED');
        },
        error: (error) => this.errorInSigning = this.translate.instant('MICROSEC_SIGN_ERROR') + error.message
    });
  }

  tryDeepLinkWithFallback(rawData: any) {
    const objectForDeepLink = {
      sessionUrl: rawData.sessionUrl,
      sessionId: rawData.sessionId,
      mode: rawData.mode,
      documents: rawData.documents
    };
    const deepLink = "esign:" + JSON.stringify(objectForDeepLink);
    
    // Store the current time to detect if the app was opened
    const startTime = Date.now();
    
    // Track if the page becomes hidden (app opened)
    let appOpened = false;
    
    const onVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
      }
    };
    
    document.addEventListener('visibilitychange', onVisibilityChange);
    
    // Use iframe to try deep link without affecting current page URL
    const iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.src = deepLink;
    document.body.appendChild(iframe);
    
    // Set a timeout to check if app was opened
    setTimeout(() => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      
      // Clean up iframe
      if (document.body.contains(iframe)) {
        document.body.removeChild(iframe);
      }
      
      // If page is still visible and not much time passed, app likely didn't open
      if (!appOpened && !document.hidden && (Date.now() - startTime) < 3000) {
        // Fallback: Open QR dialog
        console.log('App not detected, showing QR code');
        this.openMicrosecQrDialog(undefined, rawData.sessionId, rawData, this.translate.instant('MICROSEC_APP_OPEN_FAILED'), this.translate.instant('MICROSEC_CLICK_TO_SIGN'));
      }
    }, 2500);
  }

  onSendClick() {

    const tooLargeFiles = this.uploadList.files.filter(
      file => file.content.size > this.MAX_FILE_SIZE
    );

    if (tooLargeFiles.length > 0) {
      const message = this.translate.instant('REMOVE_LARGE_FILES');
      const action = this.translate.instant('OK');
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['snackbar-warning']
      });
      return;
    }

    if (this.uploadList.files.length === 0) {
      return;
    }

    this.loading = true;

    this.dmsAttachmentsService.createDmsAttachmentUpload$(this.uploadList).subscribe({
      next: () => {
        const message = this.translate.instant('ATTACHMENTS_UPLOADED');
        const action = this.translate.instant('OK');
        this._snackBar.open(message, action, {
          duration: 5000,
        });
        this.uploadList.files = [];
        this.refreshAttachments(Number(this.uploadList.elementId), this.uploadList.elementType);
        this.attachmentUploadEvent.emit();
      },
      error: () => {
        this.loading = false;
        const message = this.translate.instant('SOMETHING_WENT_WRONG');
        const action = this.translate.instant('OK');
        this._snackBar.open(message, action, {
          duration: 5000,
          panelClass: ['snackbar-warning']
        });
        this.loading = false;
      },
    });
  }

  refreshAttachments(elementId: number, elementType: string) {
    this.loading = true;
    if(elementType==='WfTask'&& !Number.isNaN(elementId)) {
      this.workflowItemService.readDmsWfTaskAttachmentsById$(elementId).subscribe(response => {
        if(response.result){
          this.attachments = [...response.result];
        }
        setTimeout(() => {
          this.loading = false;
        });
      });
    } else if (elementType==='Task'&& !Number.isNaN(elementId)) {
      this.tasksService.readDmsTaskAttachmentsById$(elementId).subscribe(response => {
        if(response.result){
          this.attachments = [...response.result];
        }
        setTimeout(() => {
          this.loading = false;
        });
      });
    } else {
      const message = this.translate.instant('SOMETHING_WENT_WRONG');
      const action = this.translate.instant('OK');
      this._snackBar.open(message, action, {
        duration: 5000,
        panelClass: ['snackbar-warning']
      });
      this.loading = false;
    }
  }

  uploadingFiles(event: Event){
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFilesToUploadList(input.files);
      input.value = '';
    }
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = false;
    const files = event.dataTransfer?.files;
    if (files) {
      this.addFilesToUploadList(files);
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    this.isDragOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(event: DragEvent) {
    if (!this.isMouseInsideDropzone(event)) {
      this.isDragOver = false;
    }
  }

  @HostListener('dragend', ['$event'])
  onDragEnd(_event: DragEvent) {
    this.isDragOver = false;
  }

  private isMouseInsideDropzone(event: DragEvent): boolean {
    const dropzone = document.querySelector('.dropzone') as HTMLElement;
    if (!dropzone) return false;
    const { top, left, bottom, right } = dropzone.getBoundingClientRect();
    const { clientX, clientY } = event;
    return clientX >= left && clientX <= right && clientY >= top && clientY <= bottom;
  }

  private addFilesToUploadList(fileList: FileList) {
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList.item(i);
      if (file) {
        this.uploadList.files.push({
          content: file,
          attachmentTypeCode: null,
          fileName: file.name
        });
        // setTimeout(() => {
        //   this.scrollToBottom();
        // }, 500);
      }
    }
  }

  removeFile(index: number) {
    this.uploadList.files.splice(index, 1);
  }

  formatFileSize(size: number): string {
    const kb = 1024;
    const mb = kb * 1024;
    const gb = mb * 1024;

    if (size >= gb) {
      return (size / gb).toFixed(2) + ' GB';
    } else if (size >= mb) {
      return (size / mb).toFixed(2) + ' MB';
    } else if (size >= kb) {
      return (size / kb).toFixed(2) + ' KB';
    } else {
      return size + ' Bytes';
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  groupActionsEnabled(): boolean {
    if (this.itemsSelected && Object.values(this.itemsSelected).some(value => value)) return true;
    return false;
  }

  singleSignatureEnabled(attachmentGuid: string): boolean {
    if (this.itemsSelected && Object.keys(this.itemsSelected).filter(key => this.itemsSelected[key]).length > 0) {
      if (Object.keys(this.itemsSelected).filter(key => this.itemsSelected[key]).length === 1 && this.itemsSelected[attachmentGuid]) return true;
      else return false;
    } else return true;
  }

  dateFormatting(timestamp: string | null, date?: boolean){
    if (timestamp && timestamp.length>1) {
      let dateArray = timestamp.split('T');
      dateArray[1] = dateArray[1].substring(0, 5);
      if (date) {
        return dateArray[0];
      } else {
        return dateArray.join(' ');
      }
    }
    else return '';
  }

  // private scrollToBottom(): void {
  //   try {
  //     this.scrollContainer.nativeElement.scrollTo({
  //       top: this.scrollContainer.nativeElement.scrollHeight,
  //       behavior: 'smooth'
  //     });
  //   } catch (err) {
  //     console.error('Scroll error:', err);
  //   }
  // }
}
